<template>
<!--<b-col md="3" sm="2" style="padding-right:3px;">-->

 <div class="int-sidebar">

	<div class="wrapper">
		<div class="top">

			<!-- <div class="int-sidebar__portion">

				<router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
					<i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp; 
				<span>Profile</span>

				</router-link>
			</div>
				 -->
			<div v-if="this.user_type=='Admin' || this.user_type=='Brand_Manager' || this.user_type=='Quality_Head' || this.user_type=='Quality_Controller'" class="int-sidebar__portion">
				<router-link to="/usersdetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
					<i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp; 
				<span>Manage Users</span>

				</router-link>
				
			</div>

			<!-- <div v-if="this.email_id=='sanjit.pal@firstcry.com'"  class="int-sidebar__portion">
				<router-link to="/inspectionTimeWindow" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Inspection Time Window" style="padding-left:30px;"> 
					<i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp; 
				<span>Inspection Time Window</span>

				</router-link>
				
			</div> -->

			

			<!-- {{this.user_type}} -->
			<div v-if="this.user_type=='Brand_Manager' || this.user_type=='Quality_Head'" class="int-sidebar__portion">
				<router-link to="/mybranddetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
					<i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp; 
				<span>My Brands</span>

				</router-link>
				
			</div>

			<div class="int-sidebar__portion" style="display:none">
				<router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
					<i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
				<span>Manage Vendors</span>

				</router-link>
				
			</div>

			<div class="int-sidebar__portion" v-if="this.user_type=='Quality_Executive'">
				<router-link to="/qcvendorslist" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
					<i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
				<span>My Vendors</span>

				</router-link>
				
			</div>

			<div v-if="this.user_type=='Admin'" class="int-sidebar__portion">
				<router-link to="/manage_brands" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
					<i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
				<span>Manage Brands</span>

				</router-link>
				
			</div>

			<div v-if="this.user_type=='Admin'" class="int-sidebar__portion">
				<router-link to="/marginmaster" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
					<i class="fa fa-pie-chart" aria-hidden="true"></i>


&nbsp;&nbsp;&nbsp; 
				<span>Manage Margin Master</span>

				</router-link>
				
			</div>


		</div>

		

		
	</div>



</div>


   
</template>
<script>

	import CONSTANTS from '@/utils/constants'
	import auth from '@/utils/auth'
	import Vue from 'vue'

	const axios = require('axios')

	export default {
	 data () {
	 	return {
	 	  nav_design_list :[],
	 	  user_type: '',	
		  email_id: "",
	 	}
	 },
	 
	 created: function() { 
	 	var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        

		var userData = localStorage.getItem('userData')
		if (userData) 
		{
			var userInfo = JSON.parse(userData)
			this.user_type = userInfo[0].user_type;
			this.email_id = userInfo[0].email_id;

			
		}
	 	

	 },

	 methods: { 
	 




	 }

	};
</script>
<style>

.middle {
  flex-grow: 1;
  overflow: auto;
  width:98%;
}

.bottom {
 position: relative;

}

 .int-sidebar.int-sidebar--notification {
   max-width: 300px !important;
   min-width: 300px !important;
   background-color: #0277bd;
   .int-sidebar__portion:first-child {
   box-shadow: inset 0 -1px 0 0 var(--fill-grey-light2);
   }
   }
   .int-sidebar {
   
    min-width: 250px;

  
   background-color: #ffffff;
   flex-direction: column;
   z-index: 2;
   :first-child {
   border-top: 0;
   }
   }
   .int-sidebar__portion {
   border-bottom: 1px solid #d4d4d4;
   border-top: 1px solid #d4d4d4;
   align-items: center;
   }
   .int-sidebar__list {
   flex-grow: 1;
   }

</style>